export const getCheckpointCompletionStatus = (
  checkpoint: PatrolCheckpoint
): CheckpointCompletionStatus => {
  const {
    ResponseTypeName,
    Time,
    DateTime,
    Comment,
    Status,
    SelectedStatusID,
    Attachments,
    SelectedDropdownIDs,
  } = checkpoint;
  if (
    ![
      "Time",
      "Comment",
      "Status",
      "Attachment",
      "Signature",
      "Dropdown",
      "DropdownMultiSelect",
      "DateTime",
    ].includes(ResponseTypeName)
  ) {
    throw new Error(
      `ResponseTypeName: ${ResponseTypeName} not configured in getCheckpointCompletionStatus.ts`
    );
  }


  if (ResponseTypeName === "DateTime" && DateTime) {
    return "Info";
  }
  if (ResponseTypeName === "Time" && Time) {
    return "Info";
  }
  if (ResponseTypeName === "Comment" && Comment) {
    return "Info";
  }
  if (ResponseTypeName === "Status") {
    const selectedStatus = Status.find(
      (status) => status.StatusID === SelectedStatusID
    );
    if (!selectedStatus) {
      return "Incomplete";
    }
    if (selectedStatus.isCommentRequired && !Comment) {
      return "Incomplete";
    }
    if (selectedStatus.StatusNumber === 1) {
      return "Clear";
    }
    if (selectedStatus.StatusNumber === 2) {
      return "Warning";
    }
    if (selectedStatus.StatusNumber === 3) {
      return "Emergency";
    }
    return "Incomplete";
  }
  if (ResponseTypeName === "Attachment" || ResponseTypeName === "Signature") {
    if (Attachments.length > 0) {
      return "Info";
    }
  }
  if (
    ResponseTypeName === "Dropdown" ||
    ResponseTypeName === "DropdownMultiSelect"
  ) {
    if (SelectedDropdownIDs.length > 0) {
      return "Info";
    }
  }
  return "Incomplete";
};
